module.exports = __webpack_public_path__ + "img/tree-06-c-trunk.dd24a292.png";